import { useEffect, useState } from "react";
import SearchVendor from "../SearchVendor";
import ListVendorsItem from "./ListVendorsItem";
import NoDataFound from "../ui/NoDataFound";
import { ConfirmDelete, MwButton, MwSpinner } from "../ui";
import { MdOutlineAddBox } from "react-icons/md";
import CardHeadeWithActions from "../ui/CardHeadeWithActions";
import { useCurrent, useDelete, useFetch } from "../../hooks";
import { useTranslation } from "react-i18next";

const ListVendors = ({ setMode, idItemSelected, setIdItemSelected }) => {
  const [showConfirmDelete, setShowConfirmDelete] = useState(false);
  const { currentTenantId, currentCompanyId, currentBranchId } = useCurrent();
  const canFetchContext = Boolean(
    currentTenantId && currentCompanyId && currentBranchId
  );
  const [vendorsList, setVendorsList] = useState();
  const { data: deleteResult, deleteItem } = useDelete();
  const { data: vendorsResult, loading, refreshHandler } = useFetch(
    canFetchContext
      ? `${process.env.REACT_APP_VENDORS_API_SERVER_BASE_URL}/${currentTenantId}/${currentCompanyId}/${currentBranchId}`
      : null
  );
  const [t] = useTranslation("global");

  const onChangeSearch = (newValue) => {
    if (newValue.length === 0) {
      refreshHandler();
    }
    setVendorsList(newValue);
  };

  const editHandeler = (id) => {
    setIdItemSelected(id);
    setMode("Edit");
  };
  const deleteHandeler = (id) => {
    setIdItemSelected(id);
    setShowConfirmDelete(true);
  };

  const confirmDelete = () => {
    deleteItem(
      `${process.env.REACT_APP_VENDORS_API_SERVER_BASE_URL}/delete/${idItemSelected}`
    );
  };

  useEffect(() => {
    if (vendorsResult) {
      setVendorsList(vendorsResult.data);
    }
  }, [vendorsResult]);

  useEffect(() => {
    if (deleteResult) {
      refreshHandler();
      setShowConfirmDelete(false);
    }
  }, [deleteResult, refreshHandler]);

  return (
    <>
      <ConfirmDelete
        onDeleteHandler={confirmDelete}
        onShow={showConfirmDelete}
        setOnShow={setShowConfirmDelete}
        msg={t("vendors.confirmDelete")}
      />
      <div className="">
        <CardHeadeWithActions title={t("vendors.vendorsList")}>
          <SearchVendor
            className={`bg-white`}
            isOpen={false}
            onChangeSearch={onChangeSearch}
          />
          <MwButton
            inGroup={true}
            type="saveBtn"
            classNameCustom="ms-2"
            onClick={() => setMode("Add")}
          >
            <MdOutlineAddBox size={18} />
            {t("vendors.addNewVendor")}
          </MwButton>
        </CardHeadeWithActions>
        <div className="my-3 ">
          {!canFetchContext && <MwSpinner />}
          {canFetchContext && loading && <MwSpinner />}
          {!loading && vendorsList && vendorsList?.length > 0 ? (
            <div className="pt-3 w-full">
              <div className="w-[98%] mx-auto">
                <div className="sticky top-0 z-10 flex w-full gap-2 bg-[#EBF9D9] font-bold py-1 px-2 rounded-t-lg text-[#261759] text-sm">
                  <div className="flex-1 text-start">اسم المورد</div>
                  <div className="w-32 shrink-0 text-center">الجوال</div>
                  <div className="w-32 shrink-0 text-center">تاريخ الإنشاء</div>
                  <div className="w-24 shrink-0 text-center">الحالة</div>
                  <div className="w-[96px] shrink-0 text-center">إجراءات</div>
                </div>
              </div>
              {vendorsList.map((item) => (
                <ListVendorsItem
                  key={item._id}
                  item={item}
                  deleteHandeler={deleteHandeler}
                  editHandeler={editHandeler}
                />
              ))}
            </div>
          ) : (
            !loading && <NoDataFound msg={t("vendors.noVendorsFound")} />
          )}
        </div>
      </div>
    </>
  );
};

export default ListVendors;
